import React from "react";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const OnBoarding = ({ step, setStep, setShowOnboarding }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        height: 1198,
        width: "100%",
        backgroundColor: "rgb(0,0,0,0.66)",
        zIndex: 1,
        color: "#fff",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: isMobile ? 30 : 81,
          height: isMobile ? 33 : 81,
          borderRadius: 12,
          border: "2px solid #fff",
          position: "absolute",
          top: isMobile ? 13 : 78,
          left: isMobile ? 30 : "20%",
          fontSize: isMobile ? 20 : 50,
        }}
      >
        {step}
      </div>
      <div
        className="w-100 d-flex justify-content-between"
        style={{
          padding: isMobile ? "0px 1.5% 0" : "0px 7.5% 0",
          marginTop: isMobile ? (step == 4 ? 900 : 600) : 400,
        }}
      >
        <ArrowForwardIosRoundedIcon
          className="m-0"
          style={{ fontSize: isMobile ? 38 : 81, cursor: "pointer" }}
          onClick={() => {
            if (step < 5) {
              setStep(step + 1);
            } else {
              setShowOnboarding(false);
              setStep(0);
            }
          }}
        />
        <ArrowBackIosRoundedIcon
          className="m-0"
          style={{ fontSize: isMobile ? 38 : 81, cursor: "pointer" }}
          onClick={() => {
            if (step > 1) {
              setStep(step - 1);
            }
          }}
        />
      </div>
    </div>
  );
};

export default OnBoarding;
